export default "__VITE_ASSET__CPea4xyw__"